import { Component } from '@angular/core';

@Component({
  selector: 'zdb-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent {}
